import React, { useState } from 'react';
import { Loader2, Truck } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { packApi } from './shared';

const plusDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
const COURIERS = ['Pallet Network', 'DPD', 'DHL', 'Parcelforce', 'UPS', 'Own van', 'Collected'];

export function DispatchDialog({ order, onClose, onDone }) {
  const [courier, setCourier] = useState('');
  const [tracking, setTracking] = useState('');
  const [edd, setEdd] = useState(plusDays(2));
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await packApi('POST', `/${order.product}/${order.id}/dispatch`, { courier, tracking_ref: tracking, expected_delivery_date: edd });
      toast.success(`${order.reference} dispatched`); onDone();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="dispatch-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Truck className="w-5 h-5" /> Dispatch {order.reference}</DialogTitle></DialogHeader>
        <div>
          <p className="text-xs text-gray-600 mb-1.5">Courier</p>
          <div className="flex flex-wrap gap-1.5">{COURIERS.map((c) => <button key={c} type="button" onClick={() => setCourier(c)} className={`px-3 py-1.5 rounded-full text-sm font-semibold border-2 ${courier === c ? 'bg-gray-900 border-gray-900 text-white' : 'bg-white border-gray-200 text-gray-700'}`} data-testid={`dispatch-courier-${c.replace(/\s+/g, '-').toLowerCase()}`}>{c}</button>)}</div>
          <Input value={courier} onChange={(e) => setCourier(e.target.value)} placeholder="or type a courier" className="mt-2" maxLength={80} data-testid="dispatch-courier" />
        </div>
        <div>
          <p className="text-xs text-gray-600 mb-1.5">Tracking / consignment ref (optional)</p>
          <Input value={tracking} onChange={(e) => setTracking(e.target.value)} placeholder="e.g. 1Z999AA10123456784" maxLength={120} className="font-mono" data-testid="dispatch-tracking" />
        </div>
        <div>
          <p className="text-xs text-gray-600 mb-1.5">Expected delivery</p>
          <Input type="date" value={edd} onChange={(e) => setEdd(e.target.value)} data-testid="dispatch-edd" />
        </div>
        <Button onClick={save} disabled={busy || !edd} className="w-full h-11 bg-amber-500 hover:bg-amber-400 text-amber-950 font-bold" data-testid="dispatch-save">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Mark as dispatched'}</Button>
      </DialogContent>
    </Dialog>
  );
}
